



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import Nomina from "@/models/tarjeta/nomina.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import moment from "moment";
@Component
export default class NominaDetalle extends BaseVue {
  @Prop() readonly value!: any | number;
  protected repository!: BaseRepository<Nomina>;
  nomina: Nomina | null = new Nomina();
  loading = false;
  constructor() {
    super();
    this.repository = new BaseRepository<Nomina>("nomina");
  }
  //    get isId() {
  //     return !isNaN(this.value);
  //   }

  @Watch("value", { deep: true, immediate: true })
  async OnValueChange(value: any) {
    if (!value) {
      this.nomina = null;
      return;
    }
    if (isNaN(value)) {
      this.nomina = this.value;
    } else {
      this.loading = true;
      this.nomina = await this.repository.byId(value, "Subsidio|Tarjeta.Banco");
      this.loading = false;
    }
    this.$emit("change", value);
  }
}
